import { useSelector } from "react-redux";
import DashboardHeader from "./dashboard/DashboardHeader";
import DashboardFooter from "./dashboard/DashboardFooter";
import { Header } from "./Header";
import Footer from "./Footer";

export default function AuthLayoutWrapper({ children }) {
  const { isAuthenticated } = useSelector((state) => state.signup);

  if (!isAuthenticated) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          background: "#f9fafb",
        }}
      >
        <Header />
        <main
          className="auth-layout-main"
          style={{
            flex: 1,
            padding: "24px",
            maxWidth: "1400px",
            margin: "0 auto",
            width: "100%",
          }}
        >
          {children}
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "#f9fafb",
      }}
    >
      <DashboardHeader />
      <main
        className="auth-layout-main"
        style={{
          flex: 1,
          padding: "24px",
          maxWidth: "1400px",
          margin: "0 auto",
          width: "100%",
        }}
      >
        {children}
      </main>
      <DashboardFooter />
    </div>
  );
}
